/**
 * ActionButton — button with primary/secondary/tertiary variants.
 */
interface ActionButtonProps {
  variant?: 'primary' | 'secondary' | 'tertiary' | 'danger';
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

const VARIANTS = {
  primary: 'bg-disney-blue-500 text-white hover:bg-disney-blue-600 disabled:opacity-50',
  secondary: 'bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-gray-100 hover:bg-gray-200 dark:hover:bg-gray-700',
  tertiary: 'text-disney-blue-500 hover:text-disney-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20',
  danger: 'text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20',
};

export function ActionButton({ variant = 'primary', children, onClick, disabled, className }: ActionButtonProps): React.ReactElement {
  return (
    <button onClick={onClick} disabled={disabled}
      className={`inline-flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-medium rounded-lg transition-colors ${VARIANTS[variant]} ${className || ''}`}>
      {children}
    </button>
  );
}
